import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { validateGeo, validateZipCode } from '../utils/queries';
export default (function () {
  var client = useApolloClient();
  var validateZip = useCallback(function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(zipcode) {
      var _yield$client$query, locationInfoByZip;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(zipcode && zipcode.length === 5)) {
              _context.next = 13;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return client.query({
              query: validateZipCode,
              variables: {
                zipcode: zipcode
              }
            });
          case 4:
            _yield$client$query = _context.sent;
            locationInfoByZip = _yield$client$query.data.locationInfoByZip;
            if (!locationInfoByZip) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", {
              zipcode: zipcode,
              zipcodeValid: locationInfoByZip.isValid,
              zipcodeError: !locationInfoByZip.isValid,
              zipcodeInfo: locationInfoByZip
            });
          case 8:
            _context.next = 12;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
          case 12:
            return _context.abrupt("return", {
              zipcode: zipcode,
              zipcodeValid: false,
              zipcodeError: true,
              zipcodeInfo: {}
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [client]);
  var validateGeolocation = useCallback(function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_ref2) {
      var latitude, longitude, _yield$client$query2, locationInfoByLatLng;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            latitude = _ref2.latitude, longitude = _ref2.longitude;
            _context2.next = 3;
            return client.query({
              query: validateGeo,
              variables: {
                latitude: latitude,
                longitude: longitude
              }
            });
          case 3:
            _yield$client$query2 = _context2.sent;
            locationInfoByLatLng = _yield$client$query2.data.locationInfoByLatLng;
            return _context2.abrupt("return", locationInfoByLatLng);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [client]);
  var customZipcodeValidator = useCallback(function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(el) {
      var result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return validateZip(el.value);
          case 2:
            result = _context3.sent;
            return _context3.abrupt("return", result && result.zipcodeValid);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [validateZip]);
  return {
    validateZip: validateZip,
    validateGeolocation: validateGeolocation,
    customZipcodeValidator: customZipcodeValidator
  };
});